import cx from "classnames";
import { ReactNode, useEffect, useRef } from "react";
import { useCustomClassContext } from "../../../hooks";
import NaturalCarousel, {
  NaturalCarouselRef,
} from "../../Utility/NaturalCarousel/NaturalCarousel";
import styles from "./listgroup.module.css";

type ListGroupProps = {
  variant?: "default" | "wrap";
  items: {
    text: string;
    url: string;
  }[];
  /* This highlights the activeTitle from the list */
  activeTitle?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * This is our list group component. It aims to display a series of content.
 */
function ListGroup({
  variant = "default",
  items,
  activeTitle,
  onClick,
}: ListGroupProps): ReactNode {
  const carouselRef = useRef<NaturalCarouselRef>(null);
  const customClass = useCustomClassContext();

  useEffect(() => {
    const foundItemIndex = items.findIndex((el) => el.text === activeTitle);

    // Subtracting 1 from index to roughly put the active item in the center
    carouselRef.current?.goTo(foundItemIndex - 1);
  }, [activeTitle, items]);

  if (variant === "wrap") {
    return (
      <div className={styles.wrappedContainer}>
        {items.map((tag, index) => (
          <a
            href={tag.url}
            key={index}
            className={cx(customClass?.tags?.secondary)}
          >
            {tag.text}
          </a>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.carouselContainer}>
      <NaturalCarousel
        isLooping={false}
        arrowSize={22}
        ref={carouselRef}
        showArrowsOnMobile
      >
        {items.map(({ text, url }, index) => (
          <a
            href={url}
            onClick={onClick}
            className={cx(
              styles.listGroupItem,
              activeTitle === text && styles.itemSelected,
            )}
            key={index}
          >
            {text}
          </a>
        ))}
      </NaturalCarousel>
    </div>
  );
}

export default ListGroup;
